import React, { useContext, useEffect, useState } from "react";
import { SvgImages } from "../../Utils/LocalImages";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import Image from "../../Components/Reusable/Image";
import { useNavigate } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";
import { handleApiErrors } from "../../Utils/Utils";
import { toast } from "react-toastify";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import PackagesService from "../../Services/PackagesService";
import { AuthContext } from "../../Context/authContext";

const Packages = () => {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [editData, setEditData] = useState({});
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [getStatusChangeData, setStatusChangeData] = useState({});
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const { user } = useContext(AuthContext)

  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await PackagesService.getAllPackages(
        offset,
        limit,
        searchQuery || ""
      );
      setData(response.data);

      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const ChangeStatus = async (id, status) => {
    try {
      await PackagesService.updatePackagesStatus(id, status);
      toast.success("Package Status Updated successfully");
      var updatedData = data;
      updatedData[
        updatedData.findIndex((item) => item._id === id)
      ].is_active = status;
      setData(updatedData);
      setShowConfirmationModal(false);
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteSinglePackage = async (id) => {
    try {
      await PackagesService.deletePackages([id]);
      toast.success("Package Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteMultiplePackages = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item._id);
          }
        });
      }
      await PackagesService.deletePackages(itemsToDelete);
      toast.success("Packages Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [offset]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (searchQuery != null) {
        fetchData();
      }
    }, 100);
    return () => clearTimeout(timeOutId);
  }, [searchQuery]);


  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0">PACKAGES</h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">Packages</h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <h1 className="black fs-18 fw-600 mb-0">Packages List</h1>
        <div className="table_title">
          <div className="table_headings mt-2 Commonclass">
            <h1 className="black fs-18 fw-600 mb-0">
              <div
                className="table_delete_icon"
                style={{
                  opacity:
                    data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                    pointerEvents: data?.findIndex((item) => item.isChecked) === -1 ? 'none' : 'auto',
                }}
                onClick={() => {

                  const packagePrivilege = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "Packages"
                  );
                  if (!packagePrivilege?.delete) {
                  
                    toast.warning("You don't have permission to delete packages.");
                    return;
                  }

                  if (!(data.findIndex((item) => item.isChecked) == -1)) {
                    setIsMultipleDelete(true);
                    setShowDeleteModal(true);
                  }
                }}
              >
                <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
              </div>
            </h1>
            <div className="d-flex gap-4 align-items-center Responsivesection">
              <div className="position-relative ">
                <input
                  type="search"
                  className="search_box search_bar"
                  placeholder="Search package name"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                />
                <Image
                  src={SvgImages.search}
                  style={ImageFilters.gray}
                  className="search_icon"
                  alt="Search Icon"
                  height="20px"
                />
              </div>
              <ButtonWithIcon
                text={"Add Packages"}
                icon={SvgImages.plus}
                onClick={() => {

                  const packagePrivilege = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "Packages"
                  );
                  if (packagePrivilege?.create) {
                    navigate(RoutesPath.addPackages, { state: null });
                  }else{
                    toast.warning("You don't have permission to add a package.")
                  }
                }}

              />
            </div>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table
              className="table mb-0 mt-3"
              id="dtHorizontalExample"
              cellSpacing="0"
              width="100%"
            >
              <thead>
                <tr className="table_heading">
                  <th scope="col" style={{ width: "5%" }}>
                    <label className="d-flex align-items-center justify-content-center">
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        style={{ height: "16px", aspectRatio: 1 }}
                        checked={
                          data?.length > 0 &&
                          data?.findIndex((item) => !item.isChecked) == -1
                        }
                        onChange={(value) => {
                          var updatedData = data;
                          updatedData.map((element) => {
                            element.isChecked = value.target.checked;
                          });
                          setData([...updatedData]);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Sr No.
                  </th>
                  <th scope="col" style={{ width: "40%" }}>
                    Package Name
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                   Class
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                  Medium
                  </th>
                  <th scope="col" style={{ width: "40%" }}>
                    Current Status
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Action
                  </th>
                </tr>
              </thead>

              <tbody className="bg_light">
                {data?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <label className="d-flex align-items-center justify-content-center">
                        <input
                          className="cursor-pointer"
                          type="checkbox"
                          checked={item.isChecked || false}
                          style={{ height: "16px", aspectRatio: 1 }}
                          onChange={(value) => {
                            var updatedData = data;
                            updatedData[index].isChecked =
                              value.target.checked;
                            setData([...updatedData]);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td>{limit * offset + (index + 1)}</td>
                    <td>{item.packageName}</td>
                    <td>{item.class_id.class_name}</td>
                    <td>{item.medium}</td>

                    <td>
                      <label
                        className="switch"
                        data-bs-target="#change_status"
                        data-bs-toggle="modal"
                      >
                        <input
                          type="checkbox"
                          checked={item.is_active}
                          onChange={() => {

                            const packagePrivilege = user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Packages"
                            )
                            if (!packagePrivilege?.update) {
                            
                              toast.warning("You don't have permission to update the status.");
                              return;
                            }

                            setShowConfirmationModal(true);
                            setStatusChangeData(item);
                          }}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                    <td>
                      <div className="d-flex gap_8">
                        <a
                          onClick={() =>{

                            const packagePrivilege = user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Packages"
                            );
                            if (!packagePrivilege?.update) {
                            
                              toast.warning("You don't have permission to edit package.");
                              return;
                            }

                            navigate(RoutesPath.editPackages, {
                              state: item,
                            })
                          }}
                          className="edit_icons cursor-pointer"
                          data-bs-target="#editclass"
                          data-bs-toggle="modal"
                        >
                          <Image
                            src={SvgImages.edit}
                            style={ImageFilters.green}
                            className="add_icons"
                            alt="Edit Icon"
                          />
                        </a>
                        <a
                          className="delete_icons cursor-pointer"
                          onClick={() => {
                            const packagePrivilege = user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Packages"
                            );
                            if (!packagePrivilege?.delete) {
                             
                              toast.warning("You don't have permission to delete package.");
                              return;
                            }

                            setDeleteId(item._id);
                            setIsMultipleDelete(false);
                            setShowDeleteModal(true);
                          }}
                        >
                          <Image
                            src={SvgImages.deleteIcon}
                            style={ImageFilters.red}
                            data-bs-target="#delete-modal"
                            data-bs-toggle="modal"
                            alt="Delete Icon"
                          />
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>


          </div>
          {generatePaginationFooter(
            availableDataCount,
            limit,
            offset,
            setOffset
          )}
        </div>

      </div>

      {/* Change Authors Status Modal */}
      <ConfirmationModal
        showModal={showConfirmationModal}
        setShowModal={setShowConfirmationModal}
        text={"Are you sure want to change the status?"}
        icon={SvgImages.exclamation_mark} // Specify the path to your delete icon
        rightClickAction={() => {
          ChangeStatus(
            getStatusChangeData._id,
            !getStatusChangeData.is_active
          );
        }}
        theme={ConfirmationModalTheme.warning}
      />

      {/* Delete Authors  Modal */}

      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete selected packages?"
            : "Are you sure want to delete this package?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete
            ? deleteMultiplePackages()
            : deleteSinglePackage(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />
    </div>
  );
};

export default Packages;
